export default __webpack_public_path__ + "static/media/OtherServices.b5b087ec.PNG";